import React from 'react';
import PropTypes from 'prop-types';
import { Header } from './Survey';

export default class SurveySuccess extends React.PureComponent {
    static defaultProps = {
        message: 'Thank you for your feedback.',
    };
    render() {
        const { message } = this.props;
        return (
            <div className="page-wrap">
                <Header />
                <div className="container">
                    <div className="text-center thks-onb">
                        <div className="icon icon--order-success svg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="72px" height="72px">
                                <g fill="none" stroke="#8EC343" strokeWidth="2">
                                    <circle cx="36" cy="36" r="35" className="survey-success-circle" />
                                    <path d="M17.417,37.778l9.93,9.909l25.444-25.393" className="survey-success-path" />
                                </g>
                            </svg>
                        </div>
                        <h2>{message}</h2>
                    </div>
                </div>
            </div>
        );
    }
}

SurveySuccess.propTypes = {
    message: PropTypes.string,
};
